import { useEffect, useState } from "react"
import { CustomRadio } from "../../../../ui/molecules/radioButton"
import Input from "../../../../ui/molecules/input"
import Button from "../../../../ui/molecules/button"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { GetAllGGNotificationGrasp, GGNotificationGraspUpdate, resetGetAllGraspStatus, resetGraspUpdateStatus, setGraspIdToUpdate, setGraspUpdateFamilyWork, setGraspUpdateFarmPermanentForeignWorker, setGraspUpdateFarmPermanentNationalWorker, setGraspUpdateFarmTemporaryForeignWorker, setGraspUpdateFarmTemporaryNationalWorker, setGraspUpdateManipulationPermanentForeignWorker, setGraspUpdateManipulationPermanentNationalWorker, setGraspUpdateManipulationTemporaryForeignWorker, setGraspUpdateManipulationTemporaryNationalWorker, setGraspUpdateRequest } from "./slice"
import { GGNotificationGraspDTO } from "./dataservice/dto"

export function GlobalGapGrasp() {
    const dispatch = useAppDispatch()
    const ggNotificationState = useAppSelector(state => state.ggNotification)
    const ggNotificationGraspState = useAppSelector(state => state.ggNotificationGrasp)
    const [familyWork, setFamilyWork] = useState<string | null>(null)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        dispatch(GetAllGGNotificationGrasp({
            itemsPerPage: 0,
            page: 0,
            ggNotificationId: ggNotificationState.ggNotificationIdToUpdate
        }))
    }, [])

    useEffect(() => {
        if (ggNotificationGraspState.getAllGraspStatus === 'successfully' &&
            ggNotificationGraspState.getAllGraspResponse !== undefined
        ) {
            dispatch(resetGetAllGraspStatus())
            const data = ggNotificationGraspState.getAllGraspResponse.data[0]
            dispatch(setGraspIdToUpdate(data.id))
            dispatch(setGraspUpdateRequest({
                familyWork: data.familyWork,
                farmPermanentNationalWorker: data.farmPermanentNationalWorker,
                farmTemporaryNationalWorker: data.farmTemporaryNationalWorker,
                farmPermanentForeignWorker: data.farmPermanentForeignWorker,
                farmTemporaryForeignWorker: data.farmTemporaryForeignWorker,
                manipulationPermanentNationalWorker: data.manipulationPermanentNationalWorker,
                manipulationTemporaryNationalWorker: data.manipulationTemporaryNationalWorker,
                manipulationPermanentForeignWorker: data.manipulationPermanentForeignWorker,
                manipulationTemporaryForeignWorker: data.manipulationTemporaryForeignWorker
            } as GGNotificationGraspDTO))
        }
    }, [ggNotificationGraspState.getAllGraspStatus])

    useEffect(() => {
        setFamilyWork(ggNotificationGraspState.graspUpdateRequest.familyWork ? 'SI' : 'NO')
    }, [ggNotificationGraspState.graspUpdateRequest])

    useEffect(() => {
        if(ggNotificationGraspState.graspUpdateStatus === 'successfully') {
            dispatch(resetGraspUpdateStatus())
            setShowSuccess(true)
        }
    }, [ggNotificationGraspState.graspUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => {
                setShowSuccess(false)
            }, 2000)
        }
    }, [showSuccess])

    return (
        <div>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '24px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="notify-container">
                <div className='notify-header'>
                    <div className='text-left'>
                        <span className='notify-title-bold' style={{ color: '#fff' }}>Domanda </span>
                        <span className='notify-title-bold' style={{ color: '#74A4A9' }}>/</span>
                        <span className='notify-title-bold' style={{ color: '#d9e6e8' }}> GRASP</span>
                    </div>
                </div>

                <div style={{ padding: '24px' }}>
                    <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                        <span className='notify-text-content'>
                            Lavoro familiare tutto l'anno
                        </span>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'SI' }]}
                                selectedValue={familyWork}
                                onChange={(value) => {
                                    setFamilyWork(value)
                                    dispatch(setGraspUpdateFamilyWork(true))
                                }}
                                id={'family_work_1'}
                                name={'family_work_1'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>Sì</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex' }}>
                            <CustomRadio
                                options={[{ label: '', value: 'NO' }]}
                                selectedValue={familyWork}
                                onChange={(value) => {
                                    setFamilyWork(value)
                                    dispatch(setGraspUpdateFamilyWork(false))
                                }}
                                id={'family_work_2'}
                                name={'family_work_2'}
                            />
                            <div className='text-left'>
                                <span className='subtitle' style={{ color: '#5a8388' }}>No</span>
                            </div>
                        </div>
                    </div>

                    <div className="pb-5 pt-5" style={{ display: 'flex', gap: '48px' }}>
                        <div style={{ flex: '0.5' }}>
                            <div className='notify-subtitle text-left pb-3'>
                                Lavoratori addetti alla campagna
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo indeterminato nazionali
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.farmPermanentNationalWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateFarmPermanentNationalWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo determinato nazionali
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.farmTemporaryNationalWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateFarmTemporaryNationalWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo indeterminato stranieri
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.farmPermanentForeignWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateFarmPermanentForeignWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo determinato stranieri
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.farmTemporaryForeignWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateFarmTemporaryForeignWorker(text))}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{ flex: '0.5' }}>
                            <div className='notify-subtitle text-left pb-3'>
                                Lavoratori addetti alla manipolazione (se applicabile)
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo indeterminato nazionali
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.manipulationPermanentNationalWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateManipulationPermanentNationalWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo determinato nazionali
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.manipulationTemporaryNationalWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateManipulationTemporaryNationalWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo indeterminato stranieri
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.manipulationPermanentForeignWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateManipulationPermanentForeignWorker(text))}
                                    />
                                </div>
                            </div>
                            <div className="pb-3" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                                <div className='notify-text-content text-left' style={{ flex: '0.5' }}>
                                    Lavoratori a tempo determinato stranieri
                                </div>
                                <div style={{ flex: '0.6' }}>
                                    <Input
                                        value={ggNotificationGraspState.graspUpdateRequest.manipulationTemporaryForeignWorker}
                                        onChangeText={(text) => dispatch(setGraspUpdateManipulationTemporaryForeignWorker(text))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '24px' }}>
                        <Button
                            variant="solid"
                            color="orange"
                            size="md"
                            iconPosition="off"
                            label="Salva"
                            onClick={() => dispatch(GGNotificationGraspUpdate({ body: ggNotificationGraspState.graspUpdateRequest, id: ggNotificationGraspState.graspIdToUpdate }))}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}